export const FAQS = {
  visa: [
    {
      question: "Which countries do you provide visa assistance for?",
      answer:
        "We assist with student visas for the USA, Canada, UK, Australia, New Zealand, Germany, Ireland, and Singapore. Each country has unique requirements, and our specialists are trained for all of them.",
      show: false,
    },
    {
      question: "What is your visa approval success rate?",
      answer:
        "We maintain a 94% first-attempt approval rate. For students with prior rejections, our reapplication success rate is 87% when following our guided process.",
      show: false,
    },
    {
      question: "How long does the visa process take?",
      answer:
        "Processing times vary by country: USA (2-8 weeks), Canada (4-12 weeks), UK (3-6 weeks), Australia (4-8 weeks). We recommend starting at least 3 months before your program start date.",
      show: false,
    },
    {
      question: "What documents do I need for a student visa?",
      answer:
        "Typically you'll need: valid passport, university offer letter, financial proof, academic transcripts, English proficiency scores (IELTS/TOEFL), medical examination (if required), and a Statement of Purpose. We provide a customized checklist for your destination.",
      show: false,
    },
    {
      question: "Can you help if my visa was previously rejected?",
      answer:
        "Yes. We specialize in reapplication cases. Our team analyzes the rejection reasons, strengthens your documentation, and prepares you thoroughly for the next interview.",
      show: false,
    },
  ],
  scholarship: [
    {
      question: "What is the Ever Sky Scholarship Program?",
      answer:
        "Our scholarship program helps deserving Indian students access funding for tuition and accommodation at partner universities in the USA, Canada, UK, Australia, and Europe.",
      show: false,
    },
    {
      question: "What are the eligibility criteria?",
      answer:
        "Candidates must be Indian citizens with a high school diploma, family income under ₹6 lakh/year, minimum IELTS 6.0 bands, and admission to a full-time program of at least one year at a partner institution.",
      show: false,
    },
    {
      question: "How much scholarship can I receive?",
      answer:
        "Scholarship amounts range from ₹2 lakh to full tuition coverage depending on academic merit, financial need, and the partner university's available funds.",
      show: false,
    },
    {
      question: "How do I apply for the scholarship?",
      answer:
        "Submit your profile for assessment, complete our scholarship application form with a supporting essay, attend an interview with our scholarship committee, and receive your award decision within 4-6 weeks.",
      show: false,
    },
  ],
  accommodation: [
    {
      question: "How does Ever Sky help with student accommodation?",
      answer:
        "We partner with verified housing providers near major universities. Browse options, compare prices, and book securely through our platform — all before you leave India.",
      show: false,
    },
    {
      question: "What types of accommodation are available?",
      answer:
        "Options include university dormitories, private student apartments, homestays, and shared housing. All listings are verified for safety, hygiene, and proximity to campus.",
      show: false,
    },
    {
      question: "Can I book accommodation before getting my visa?",
      answer:
        "We recommend waiting for visa approval before finalizing accommodation. However, you can shortlist and reserve options with flexible cancellation policies.",
      show: false,
    },
    {
      question: "What is included in the accommodation fee?",
      answer:
        "This varies by property. Most include rent, utilities, and Wi-Fi. Meals, laundry, and cleaning may be additional. We provide a detailed breakdown for each listing.",
      show: false,
    },
  ],
  resume: [
    {
      question: "What documents can you help me write?",
      answer:
        "We write Statements of Purpose (SOP), Letters of Recommendation (LOR), resumes/CVs, cover letters, study plans, and scholarship essays tailored to your target programs.",
      show: false,
    },
    {
      question: "How long does the writing process take?",
      answer:
        "Standard turnaround is 5-7 business days. Express delivery (2-3 days) is available for an additional fee. Revisions are included at no extra cost.",
      show: false,
    },
    {
      question: "Do you guarantee university admission?",
      answer:
        "While we cannot guarantee admission, our professionally crafted documents significantly improve your application's competitiveness. 89% of our clients receive at least one offer.",
      show: false,
    },
    {
      question: "Can I request revisions?",
      answer:
        "Yes. Each package includes up to 3 rounds of revisions. We work closely with you until you're completely satisfied with the final document.",
      show: false,
    },
  ],
  air: [
    {
      question: "Do you offer student discounts on flights?",
      answer:
        "Yes. We have partnerships with major airlines offering exclusive student fares with extra baggage allowance and flexible date changes.",
      show: false,
    },
    {
      question: "When should I book my flight?",
      answer:
        "Book 2-3 months before departure for the best rates. We monitor prices and alert you when fares drop for your route.",
      show: false,
    },
    {
      question: "What if my visa is delayed and I need to change dates?",
      answer:
        "We assist with date changes and rebooking. Student fare tickets often include one free date change. We'll handle the airline coordination for you.",
      show: false,
    },
    {
      question: "Can you arrange group bookings?",
      answer:
        "Absolutely. If multiple students are traveling to the same destination, we arrange group bookings with additional discounts.",
      show: false,
    },
  ],
  sim: [
    {
      question: "When will I receive my international SIM?",
      answer:
        "SIM cards are delivered to your Indian address 7-10 days before your departure date, pre-activated and ready to use upon landing.",
      show: false,
    },
    {
      question: "Which countries are covered?",
      answer:
        "We provide SIM cards for the USA, Canada, UK, Australia, New Zealand, Germany, and most European countries.",
      show: false,
    },
    {
      question: "What data plans are available?",
      answer:
        "Plans range from 5GB to unlimited data with international calling. We recommend plans based on your destination and expected usage.",
      show: false,
    },
    {
      question: "Can I keep my Indian number active?",
      answer:
        "Yes. We advise on dual-SIM phone setup so you can use both your Indian and international numbers simultaneously.",
      show: false,
    },
  ],
  general: [
    {
      question: "How do I get started with Ever Sky Overseas?",
      answer:
        "Book a free consultation through our website or call us directly. A counsellor will assess your profile and recommend the best path forward.",
      show: false,
    },
    {
      question: "What are your service fees?",
      answer:
        "We offer transparent pricing starting from ₹4,999. Visit our Pricing page for detailed packages, or contact us for a customized quote.",
      show: false,
    },
    {
      question: "Do you offer refunds?",
      answer:
        "Refunds are available per our refund policy. Service fees for completed work are non-refundable, but unused package components may be eligible for partial refunds.",
      show: false,
    },
    {
      question: "Can I pay in installments?",
      answer:
        "Yes. Premium and Elite packages support 2-3 installment payments. Contact our team to set up a payment plan.",
      show: false,
    },
  ],
};
